import type { DateNavigator } from '@devexpress/dx-react-scheduler-material-ui';
import React from 'react';

import { DateInput } from '@components/DateInput';

import { DatePickerWrapper } from './DateNavigator.style';

/**
 * VITALL-styled calendar overlay component for the routine scheduler toolbar
 */
const CalendarOverlay = ({
  currentDate,
  onDateChange,
  ...props
}: DateNavigator.OverlayProps & {
  currentDate: Date;
  onDateChange: (date: Date) => void;
}) => {
  const { onHide, target } = props;
  let top = 0;
  let left = 0;
  if (target instanceof HTMLElement) {
    const { offsetTop, offsetLeft } = target;
    const domRect = target.getBoundingClientRect();
    top = offsetTop + domRect.height / 2;
    left = offsetLeft - domRect.width / 4;
  }
  const handleDateChange = (value: Date | null): void => {
    if (value instanceof Date) {
      onDateChange(value);
    }
  };

  return (
    <DatePickerWrapper left={left} top={top}>
      <DateInput
        onBlur={() => onHide()}
        onChange={handleDateChange}
        value={currentDate}
      />
    </DatePickerWrapper>
  );
};

export default CalendarOverlay;
